export enum Command {
  SET_AUDIO_TRACK = 'setAudioTrack',
  SET_SUBTITLE_TRACK = 'setSubtitleTrack',
  LOAD = 'load',
  PLAY = 'play',
  PAUSE = 'pause',
  STOP = 'stop',
  SET_VIDEO_STARTING_BANDWIDTH = 'setVideoStartingBandwidth',
  SET_PLAYTIME = 'setPlayTime',
  GET_SEEKWINDOW = 'getSeekWindow',
  SET_FIX_VIDEO_REPRESENTATIONS = 'setFixVideoRepresentations',
  GET_AUDIO_TRACKS = 'getAudioTracks',
  GET_SUBTITLE_TRACKS = 'getSubtitleTracks',
  SET_TIMED_METADATA = 'setTimedMetadata',
  SET_CLOSED_CAPTIONS = 'setClosedCaptions',
  GET_PLAY_TIME = 'getPlaybackTime',
  GET_PLAY_SPEED = 'getPlaySpeed',
  SET_PLAY_SPEED = 'setPlaySpeed',
  SET_VOLUME = 'setVolume',

  // Application response commands
  PLAYER_STATUS_CHANGE = 'playerStatusChange',
  PLAYER_STREAMING_ERROR = 'playerStreamingError',
  PLAYER_ERROR = 'playerError',
  PLAYER_MESSAGE = 'playerMessage',
  PLAYER_TIMED_EVENT = 'playerTimedEvent',
}
